
import Edit from './edit.js';

const { registerBlockType }   =   wp.blocks;

const { RichText, InnerBlocks }  =   wp.blockEditor;

registerBlockType( 'diviner-blocks/cta', {
    // Built-in Attributes
    title: 'Call to Action',
    description: 'Custom Call to Action Button',
    icon: {
        foreground: '#1d7eb6',
        src: 'flag'
    },
    category: 'diviner-blocks',

    //Custom Attributes
    attributes: {
        body: {
            type: 'string',
            source: 'html',
            selector: 'p'
        },
        bodyColor: {
            type: 'string',
            default: 'black'
        },
        bgImage: {
            type: 'object',
            default: {}
        },
        overlayColor: {
            type: 'string',
            default: 'black'
        },
        overlayOpacity: {
            type: 'number',
            default: 0.3
        }
    },

    edit: Edit,

    save: (props) => {

        const { attributes } = props;
		console.log(attributes);
        return (
            <div className="cta-container" style={ {
                backgroundImage: `url(${attributes.bgImage.url})`,
                } }>
                <div className="cta-overlay" style={ { background: attributes.overlayColor, opacity: attributes.overlayOpacity } }>
                </div>

                <RichText.Content tagName="p"
                                  value={ attributes.body }
                                  style={ { color: attributes.bodyColor } } />

                <InnerBlocks.Content />
            </div>
        );
    }
});

alert('11');
